<template>
	<div :class="['box', 'is-shadowless']">
		<h3
			v-if="heading"
			class="title is-4 has-text-weight-bold column-title"
			v-text="heading"
		/>
		<div v-if="chartData" class="chart">
			<component
				:is="`${type}Chart`"
				:chart-data="chartData.data"
				:options="options"
				:x-scale-label="xScaleLabel"
				:y-scale-label="yScaleLabel"
				:show-tooltip="showTooltip"
				:prepend-tooltip="prependtooltip"
			></component>
		</div>
		<div v-else>
			<dc-icon v-if="isFetching" icon="sync" no-margin spin />
			<span v-text="label" />
		</div>
	</div>
</template>

<script>
import sourceMixin from "../Layouts/components/sourceMixin";
import barChart from "./BarChart";
import HorizontalBarChart from "./HorizontalBarChart";
import lineChart from "./LineChart";
import timelineChart from "./TimeLineChart";
import pieChart from "./PieChart";
import doughnutChart from "./DoughnutChart";
import scatterChart from "./ScatterChart";

export default {
	components: {
		barChart,
		HorizontalBarChart,
		lineChart,
		pieChart,
		doughnutChart,
		scatterChart,
		timelineChart
	},
	mixins: [sourceMixin],
	props: {
		options: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			chartData: null
		};
	},
	computed: {
		heading() {
			return this.data.title;
		},
		type() {
			return this.chartData.type;
		},
		xScaleLabel() {
			return this.data.xScaleLabel || null;
		},
		yScaleLabel() {
			return this.data.yScaleLabel || null;
		},
		showTooltip() {
			return this.data.charttooltip;
		},
		prependtooltip() {
			return this.data.prependtooltip || "";
		},
		borderCheck() {
			return this.data.hideborder === "yes" ? "no-border" : "";
		}
	},
	methods: {
		async fetchData() {
			this.isFetching = true;
			this.chartData = null;
			this.label = "Loading";

			if (!this.isValid(this.source)) {
				this.isFetching = false;
				return;
			}
			await this.fetchSource(this.source).then(
				(response) => {
					this.chartData = response;
					this.isFetching = false;
					if (!response) {
						this.label = this.errorMessage;
					}
				},
				() => {
					this.label = this.errorMessage;
					this.isFetching = false;
				}
			);
		}
	}
};
</script>

<style scoped>
/* .column-title {
	min-height: auto;
	margin-top: 2.5em;
} */
.chart {
	max-height: 600px;
}
.no-border {
	border: none !important;
	box-shadow: none;
	padding-left: 0;
	padding-right: 0;
}
</style>
